/**
 * React Query hook for an idea's measured impact (organic vs paid).
 *
 * Resolves the active ``HttpClient`` so it works in both admin and
 * portal trees, mirroring ``useIdeaQuery``.
 */

import { useQuery } from "@tanstack/react-query";
import { useHttpClient } from "@/core/http/HttpClientContext";
import { getIdeaImpact, IdeaImpact } from "../services/ideaImpact";

export function useIdeaImpactQuery(ideaId: string | undefined, enabled = true) {
  const http = useHttpClient();
  return useQuery<IdeaImpact>({
    queryKey: ideaId ? ["idea-impact", ideaId, http.context.kind] : ["idea-impact", "none"],
    queryFn: async () => getIdeaImpact(http, ideaId as string),
    enabled: Boolean(ideaId) && enabled,
  });
}
